/**
 * App Link → mevcut hash rotası eşlemesi.
 *
 * Capacitor uygulaması üretimde `https://oynat.aegisvault.xyz` origin'ini
 * yükler; mevcut router hash tabanlıdır. Bu saf fonksiyon, native katmandan
 * gelen URL'nin yalnızca aynı origin'deki hash bölümünü kabul eder.
 */
export function hashFromAppUrl(url: string, origin: string): string | null {
  try {
    const parsed = new URL(url);
    if (parsed.origin !== origin) return null;
    return parsed.hash.length > 1 ? parsed.hash : null;
  } catch {
    return null;
  }
}
